/* IT HIPPIE - bloc promo newsletter du tiroir (v3 — compatible navigateurs Instagram / Facebook).

   PROBLÈME CORRIGÉ (oct. 2026) :
   la v2 soumettait le formulaire en natif vers /contact → toute la page se rechargeait
   (+ page captcha éventuelle). Dans le navigateur intégré d'Instagram, la cliente se
   retrouvait sur une autre page, tiroir fermé, et parfois avec un panier vide.

   NOUVEAU FONCTIONNEMENT :
   1. L'inscription part en arrière-plan (fetch) : la page ne bouge pas.
   2. Le code est appliqué directement au panier (/cart/update.js { discount }).
   3. Le tiroir est rafraîchi sur place : confirmation + prix barré immédiats.
   4. Si Shopify exige un captcha : sauvegarde du panier, soumission native (le captcha
      s'affiche), puis au retour le panier est restauré automatiquement s'il a été perdu.
   5. (retiré le 17 oct.) Pré-remplissage de l'email au checkout par permalien.
   6. Masquage / confirmation pour les clientes déjà inscrites.

   v3.1 (17 oct.) — fluidité : inscription et code partent en parallèle, le nouveau
   contenu du panier arrive dans la même réponse que le code ; confirmation et prix
   barré s'affichent ensemble, sans rejouer l'animation du bloc ni remonter la liste. */
(function () {
  if (window.__ithPromoBound) return;
  window.__ithPromoBound = true;

  var BACKUP_KEY = 'ithippie_cart_backup';
  var BACKUP_TTL = 2 * 60 * 60 * 1000; // 2 h

  var LS = {
    get: function (k) { try { return localStorage.getItem(k); } catch (e) { return null; } },
    set: function (k, v) { try { localStorage.setItem(k, v); } catch (e) {} },
    del: function (k) { try { localStorage.removeItem(k); } catch (e) {} }
  };

  function getCode() {
    var box = document.getElementById('cart-promo-newsletter');
    return (box && box.dataset.code) ? box.dataset.code : 'HELLO10';
  }

  function getJSON(url) {
    return fetch(url, { credentials: 'same-origin', cache: 'no-store', headers: { 'Accept': 'application/json' } })
      .then(function (r) { if (!r.ok) throw new Error(url); return r.json(); });
  }

  function postJSON(url, body) {
    return fetch(url, {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(body)
    }).then(function (r) { if (!r.ok) throw new Error(url); return r.json(); });
  }

  /* ---------- Tiroir ---------- */
  function drawerSectionId() {
    var cd = document.querySelector('cart-drawer');
    var wrap = (cd && cd.closest) ? cd.closest('[id^="shopify-section-"]') : null;
    return wrap ? wrap.id.replace('shopify-section-', '') : 'cart-drawer';
  }

  function updateCounters(cart) {
    if (typeof window.updateCartCounters === 'function') { try { window.updateCartCounters(); return; } catch (e) {} }
    var p = cart ? Promise.resolve(cart) : getJSON('/cart.js');
    p.then(function (c) {
      document.querySelectorAll('[data-cart-count], .cart-count, .header__cart-count, .cart-counter').forEach(function (el) {
        el.textContent = c.item_count;
      });
    }).catch(function () {});
  }

  var SCROLLERS = '#CartDrawer-Body, .cart-drawer__body, .cart-drawer__inner, .cart-drawer__main, .cart-drawer-items';

  /* Remplace le contenu du tiroir en gardant la position de défilement */
  function renderDrawer(html) {
    var cd = document.querySelector('cart-drawer');
    if (!cd || !html) return false;
    var tmp = document.createElement('div');
    tmp.innerHTML = html;
    var fresh = tmp.querySelector('cart-drawer');
    if (!fresh) return false;
    var pos = [];
    cd.querySelectorAll(SCROLLERS).forEach(function (el, i) { pos[i] = el.scrollTop; });
    cd.innerHTML = fresh.innerHTML;
    applyPromoState(true);
    cd.querySelectorAll(SCROLLERS).forEach(function (el, i) { if (pos[i]) el.scrollTop = pos[i]; });
    updateCounters();
    return true;
  }

  function refreshDrawer() {
    var cd = document.querySelector('cart-drawer');
    if (!cd) return Promise.resolve();
    var sid = drawerSectionId();
    return fetch(window.location.pathname + '?sections=' + encodeURIComponent(sid), { credentials: 'same-origin', cache: 'no-store' })
      .then(function (r) { if (!r.ok) throw new Error('sections'); return r.json(); })
      .then(function (json) { renderDrawer(json && json[sid]); });
  }

  function openDrawer() {
    var cd = document.querySelector('cart-drawer');
    if (cd && typeof cd.open === 'function') { try { cd.open(); } catch (e) {} }
  }

  /* ---------- Code promo ---------- */
  /* Pose le code sur le panier. Résout avec le HTML du tiroir mis à jour (ou null). */
  function applyDiscount() {
    var code = getCode();
    var sid = drawerSectionId();
    /* Filet de sécurité en parallèle : cookie discount (sans suivre la redirection) */
    try { fetch('/discount/' + encodeURIComponent(code), { credentials: 'same-origin', redirect: 'manual' }).catch(function () {}); } catch (e) {}
    return postJSON('/cart/update.js', { discount: code, sections: sid, sections_url: window.location.pathname })
      .then(function (res) { return (res && res.sections && res.sections[sid]) || null; })
      .catch(function () { return null; });
  }

  /* Affiche le panier à jour (HTML déjà reçu, sinon nouvelle requête) */
  function showDrawer(html) {
    if (html && renderDrawer(html)) return Promise.resolve();
    return refreshDrawer().catch(function () {});
  }

  /* ---------- Sauvegarde / restauration du panier (uniquement chemin captcha) ---------- */
  function backupCart() {
    return getJSON('/cart.js').then(function (cart) {
      if (!cart || !cart.items || !cart.items.length) return;
      LS.set(BACKUP_KEY, JSON.stringify({
        t: Date.now(),
        items: cart.items.map(function (it) {
          return { id: it.variant_id, quantity: it.quantity, properties: it.properties || {} };
        })
      }));
    }).catch(function () {});
  }

  function restoreCartIfLost() {
    var raw = LS.get(BACKUP_KEY);
    if (!raw) return Promise.resolve(false);
    LS.del(BACKUP_KEY);
    var bk = null;
    try { bk = JSON.parse(raw); } catch (e) {}
    if (!bk || !bk.items || !bk.items.length || (Date.now() - (bk.t || 0)) > BACKUP_TTL) return Promise.resolve(false);
    return getJSON('/cart.js').then(function (cart) {
      if (cart && cart.item_count > 0) return false; // panier intact : rien à faire
      return postJSON('/cart/add.js', { items: bk.items }).then(function () { return true; });
    }).catch(function () { return false; });
  }

  /* ---------- État visuel du bloc ---------- */
  function applyPromoState(instant) {
    var done = LS.get('ithippie_promo_done') === '1';
    var posted = LS.get('ithippie_promo_posted') === '1';
    var box = document.getElementById('cart-promo-newsletter');
    if (!box) return;

    if (posted) {
      var form = document.getElementById('cart-promo-form') || box.querySelector('form');
      var confirmEl = document.getElementById('cart-promo-confirm');
      var body = box.querySelector('.cart-promo-newsletter__body');
      if (instant === true && body && !box.classList.contains('is-open')) {
        /* bloc fraîchement re-rendu : on l'ouvre sans rejouer l'animation */
        body.style.transition = 'none';
        box.classList.add('is-open');
        void body.offsetHeight;
        setTimeout(function () { body.style.transition = ''; }, 50);
      }
      box.classList.add('is-open');
      if (form) form.style.display = 'none';
      if (confirmEl) confirmEl.style.display = 'flex';
      box.style.display = '';
      return;
    }
    box.style.display = done ? 'none' : '';
  }

  function markSubscribed() {
    LS.set('ithippie_promo_done', '1');
    LS.set('ithippie_promo_posted', '1');
    LS.del('ithippie_promo_pending');
    applyPromoState();
  }

  function setBusy(form, busy) {
    var btn = form.querySelector('button[type="submit"]');
    if (!btn) return;
    if (busy) {
      btn.dataset.label = btn.dataset.label || btn.textContent;
      btn.disabled = true;
      btn.textContent = '…';
    } else {
      btn.disabled = false;
      if (btn.dataset.label) btn.textContent = btn.dataset.label;
    }
  }

  /* Captcha exigé par Shopify : on sauvegarde le panier puis soumission native */
  function nativeFallback(form) {
    LS.set('ithippie_promo_pending', '1');
    return Promise.all([backupCart(), applyDiscount()]).then(function () {
      form.__ithNative = true;
      HTMLFormElement.prototype.submit.call(form);
    });
  }

  /* ---------- Clics : accordéon + bouton Commander ---------- */
  document.addEventListener('click', function (e) {
    if (!e.target || !e.target.closest) return;

    var toggle = e.target.closest('#cart-promo-toggle');
    if (toggle) {
      var box = document.getElementById('cart-promo-newsletter');
      if (!box) return;
      var open = box.classList.toggle('is-open');
      toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
      if (open) { var inp = document.getElementById('cart-promo-email'); if (inp) setTimeout(function () { inp.focus(); }, 60); }
      return;
    }
    /* 17 oct. : le bouton Commander n'est plus intercepté (avant : reconstruction du panier
       par permalien pour pré-remplir l'email → redirection en plus dans Instagram et risque
       de perdre des infos d'articles). Le paiement Shopify standard est utilisé. */
  });

  /* ---------- Soumission : en arrière-plan, la page ne bouge pas ---------- */
  document.addEventListener('submit', function (e) {
    var form = (e.target && e.target.closest) ? e.target.closest('form') : null;
    if (!form || !form.closest('#cart-promo-newsletter')) return;
    if (form.__ithNative) return; // soumission native volontaire (captcha)

    e.preventDefault();

    var inp = form.querySelector('#cart-promo-email') || form.querySelector('input[type="email"]');
    var email = inp ? inp.value.trim() : '';
    if (!email) {
      if (inp) inp.classList.add('cart-promo-newsletter__input--error');
      return;
    }
    if (inp) inp.classList.remove('cart-promo-newsletter__input--error');
    LS.set('ithippie_promo_email', email);
    setBusy(form, true);

    var subscribe = fetch(form.getAttribute('action') || '/contact', {
      method: 'POST',
      body: new FormData(form),
      credentials: 'same-origin',
      headers: { 'Accept': 'text/html' }
    }).then(function (r) {
      if (/\/challenge/.test(r.url || '')) { var err = new Error('captcha'); err.captcha = true; throw err; }
      if (!r.ok) throw new Error('post');
    });

    /* Inscription et code en parallèle : on attend les deux, puis tout s'affiche d'un coup */
    Promise.all([subscribe, applyDiscount()])
      .then(function (res) {
        markSubscribed();
        return showDrawer(res[1]);
      })
      .catch(function () {
        /* captcha ou erreur réseau : on bascule sur la méthode native, panier sauvegardé */
        return nativeFallback(form).catch(function () { setBusy(form, false); });
      });
  });

  function init() {
    var returned = window.location.search.indexOf('customer_posted=true') !== -1;
    var pending = LS.get('ithippie_promo_pending') === '1';

    /* Restauration du panier si la cliente l'a perdu pendant le captcha */
    restoreCartIfLost().then(function (restored) {
      if (returned && pending) {
        markSubscribed();
        return applyDiscount().then(showDrawer).then(function () {
          setTimeout(openDrawer, 300);
        });
      }
      if (restored) {
        return refreshDrawer().then(function () { setTimeout(openDrawer, 300); });
      }
    }).catch(function () {}).then(applyPromoState);

    applyPromoState(true);
    var dr = document.querySelector('cart-drawer') || document.body;
    if (window.MutationObserver) {
      new MutationObserver(function () { applyPromoState(true); }).observe(dr, { childList: true, subtree: true });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  document.addEventListener('cart:refresh', applyPromoState);
})();


/* ====================================================================
   TOTE BAG OFFERT — choix du coloris (v5)
   Anciennement en ligne dans snippets/cart-tote-choice.liquid. Regroupé ici
   pour être chargé une seule fois par page : un <script> injecté lors du
   rafraîchissement AJAX du tiroir n'est jamais exécuté, les boutons ne
   marchaient donc pas après un ajout au panier (cas systématique depuis
   une pub Instagram).

   v5 (17 oct.) — transition « Valider mon coloris » :
   - le pop-up ne devient plus semi-transparent pendant l'enregistrement
     (on voyait la collection et le pop-up en même temps) ;
   - un seul appel à Shopify au lieu de 4-5 (/cart/update.js renvoie
     directement le nouveau contenu du tiroir) → beaucoup plus rapide ;
   - le tiroir s'ouvre d'abord SOUS le pop-up, puis le pop-up disparaît en
     fondu : on passe directement du pop-up au panier.
   ==================================================================== */
(function () {
  if (window.__tcChoice) return;
  window.__tcChoice = 1;

  var REOPEN_KEY = 'tcReopenDrawer';

  var CSS =
    '.tcm{position:fixed;inset:0;z-index:2147483647;display:none;opacity:1;transition:opacity .25s ease}' +
    '.tcm.is-open{display:block}' +
    '.tcm.is-leaving{opacity:0;pointer-events:none}' +
    '.tcm__overlay{position:absolute;inset:0;background:rgba(42,38,34,.5)}' +
    '.tcm__box{position:absolute;left:50%;bottom:0;transform:translateX(-50%);width:100%;max-width:440px;max-height:92vh;overflow-y:auto;-webkit-overflow-scrolling:touch;background:#FBF8F1;border-radius:16px 16px 0 0;padding:20px 20px 26px;box-sizing:border-box;font-family:inherit;color:#222}' +
    '@media (min-width:750px){.tcm__box{bottom:auto;top:50%;transform:translate(-50%,-50%);border-radius:12px}}' +
    '.tcm__close{position:absolute;top:10px;right:12px;background:none;border:none;font-size:26px;line-height:1;cursor:pointer;color:#222}' +
    '.tcm__kicker{font-size:10px;letter-spacing:.18em;text-transform:uppercase;color:#6E1C24;margin:0 0 6px}' +
    '.tcm__title{font-family:Georgia,serif;font-size:22px;margin:0 0 14px}' +
    '.tcm__photo{width:100%;aspect-ratio:4/5;max-height:52vh;object-fit:cover;border-radius:10px;background:#e9e1d3;display:block;margin:0 auto;transition:opacity .2s ease}' +
    '.tcm__name{text-align:center;font-size:13px;color:#444;margin:12px 0 10px}' +
    '.tcm__chips{display:flex;justify-content:center;gap:14px}' +
    '.tcm__chip{width:34px;height:34px;border-radius:50%;border:1px solid rgba(0,0,0,.15);padding:0;cursor:pointer;box-sizing:border-box;-webkit-tap-highlight-color:transparent}' +
    '.tcm__chip.is-active{box-shadow:0 0 0 2px #FBF8F1,0 0 0 4px #6E1C24}' +
    '.tcm__validate{display:flex;align-items:center;justify-content:center;gap:10px;width:100%;margin-top:18px;background:#6E1C24;color:#FBF8F1;border:none;border-radius:8px;padding:15px;font-size:14px;font-weight:700;letter-spacing:.08em;cursor:pointer}' +
    '.tcm__validate[disabled]{opacity:.45;cursor:default}' +
    '.tcm.is-busy .tcm__validate[disabled]{opacity:1;cursor:wait}' +
    '.tcm__spin{display:none;width:15px;height:15px;border:2px solid rgba(251,248,241,.35);border-top-color:#FBF8F1;border-radius:50%;animation:tcmspin .7s linear infinite}' +
    '.tcm.is-busy .tcm__spin{display:inline-block}' +
    '@keyframes tcmspin{to{transform:rotate(360deg)}}' +
    '.tcm__skip{display:block;width:100%;margin-top:12px;background:none;border:none;font-size:12px;color:#8a7d6c;text-decoration:underline;cursor:pointer}' +
    '.tcm__err{display:none;text-align:center;font-size:12px;color:#b03a3a;margin:10px 0 0}' +
    '.tcm__err.is-visible{display:block}' +
    '.tcm.is-busy .tcm__box{pointer-events:none}' +
    '.tcm.is-busy .tcm__chips,.tcm.is-busy .tcm__skip{opacity:.5}' +
    '.tc.is-busy{opacity:.6;pointer-events:none}';

  function injectCss() {
    if (document.getElementById('tcm-style')) return;
    var s = document.createElement('style');
    s.id = 'tcm-style';
    s.textContent = CSS;
    (document.head || document.body).appendChild(s);
  }

  function getOpts() {
    var el = document.querySelector('[data-tc-options]');
    if (!el) return [];
    try { return JSON.parse(el.textContent) || []; } catch (e) { return []; }
  }

  function json(url) {
    return fetch(url, { credentials: 'same-origin', cache: 'no-store', headers: { 'Accept': 'application/json' } })
      .then(function (r) { if (!r.ok) throw new Error(url); return r.json(); });
  }
  function post(url, body) {
    return fetch(url, {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(body)
    }).then(function (r) { if (!r.ok) throw new Error(url); return r.json(); });
  }
  function isTote(it) { return /martial/i.test(it.handle || ''); }

  /* ---------- Tiroir ---------- */
  function drawer() { return document.querySelector('cart-drawer'); }

  function sectionId() {
    var cd = drawer();
    var wrap = (cd && cd.closest) ? cd.closest('[id^="shopify-section-"]') : null;
    return wrap ? wrap.id.replace('shopify-section-', '') : 'cart-drawer';
  }

  function openDrawer() {
    var cd = drawer();
    if (!cd) return;
    if (typeof cd.open === 'function') { try { cd.open(); } catch (e) {} } else { cd.classList.add('is-visible'); }
  }
  function closeDrawer() {
    var cd = drawer();
    if (!cd) return;
    if (typeof cd.close === 'function') { try { cd.close(); } catch (e) {} } else { cd.classList.remove('is-visible'); }
  }

  /* Remplace le contenu du tiroir par le HTML de section renvoyé par Shopify */
  function renderDrawer(html) {
    var cd = drawer();
    if (!cd || !html) return false;
    var tmp = document.createElement('div');
    tmp.innerHTML = html;
    var fresh = tmp.querySelector('cart-drawer');
    if (!fresh) return false;
    cd.innerHTML = fresh.innerHTML;
    if (typeof window.updateCartCounters === 'function') { try { window.updateCartCounters(); } catch (e) {} }
    return true;
  }

  function fetchDrawer() {
    var sid = sectionId();
    return fetch(window.location.pathname + '?sections=' + encodeURIComponent(sid), { credentials: 'same-origin', cache: 'no-store' })
      .then(function (r) { if (!r.ok) throw new Error('sections'); return r.json(); })
      .then(function (data) { if (!renderDrawer(data && data[sid])) throw new Error('sections'); });
  }

  function reloadAndReopen() {
    try { sessionStorage.setItem(REOPEN_KEY, '1'); } catch (e) {}
    window.location.reload();
  }

  function reopenAfterReload() {
    var go = false;
    try { go = sessionStorage.getItem(REOPEN_KEY) === '1'; sessionStorage.removeItem(REOPEN_KEY); } catch (e) {}
    if (go) setTimeout(openDrawer, 300);
  }

  /* Un seul appel : met à jour les lignes tote ET récupère le nouveau tiroir */
  function updateTotes(keepHandle, keepVariant) {
    return json('/cart.js').then(function (cart) {
      var updates = {};
      var has = false;
      cart.items.forEach(function (it) {
        if (!isTote(it)) return;
        if (keepHandle && it.handle === keepHandle) { has = true; return; }
        updates[it.key] = 0;
      });
      if (keepVariant && !has) updates[keepVariant] = 1;
      var sid = sectionId();
      return post('/cart/update.js', { updates: updates, sections: sid, sections_url: window.location.pathname })
        .then(function (res) {
          if (res && res.sections && renderDrawer(res.sections[sid])) return;
          return fetchDrawer();
        });
    });
  }

  /* ---------- Pop-up coloris ---------- */
  var modal = null, selected = null, opts = [];

  function buildModal() {
    injectCss();
    var el = document.createElement('div');
    el.className = 'tcm';
    el.innerHTML =
      '<div class="tcm__overlay" data-tcm-close></div>' +
      '<div class="tcm__box" role="dialog" aria-modal="true" aria-label="Choisir votre tote bag">' +
        '<button type="button" class="tcm__close" data-tcm-close aria-label="Fermer">&times;</button>' +
        '<p class="tcm__kicker">Offert dès 150 €</p>' +
        '<p class="tcm__title">Choisissez votre tote bag</p>' +
        '<img class="tcm__photo" data-tcm-photo alt="">' +
        '<p class="tcm__name" data-tcm-name></p>' +
        '<div class="tcm__chips"></div>' +
        '<button type="button" class="tcm__validate" data-tcm-validate disabled><span class="tcm__spin" aria-hidden="true"></span><span data-tcm-vlabel>Valider mon coloris</span></button>' +
        '<button type="button" class="tcm__skip" data-tcm-decline>Ne pas le recevoir</button>' +
        '<p class="tcm__err" data-tcm-err>Oups, ça n\'a pas marché. Réessayez.</p>' +
      '</div>';
    document.body.appendChild(el);

    el.addEventListener('click', function (e) {
      var t = e.target;
      if (!t || !t.closest) return;
      if (t.closest('[data-tcm-close]')) { closeModal(); return; }
      var chip = t.closest('[data-tcm-chip]');
      if (chip) { choose(chip.getAttribute('data-tcm-chip')); return; }
      if (t.closest('[data-tcm-validate]')) { validate(); return; }
      if (t.closest('[data-tcm-decline]')) { decline(); return; }
    });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeModal(); });
    return el;
  }

  function renderChips() {
    var chips = modal.querySelector('.tcm__chips');
    chips.innerHTML = '';
    opts.forEach(function (o) {
      if (!o.variant) return; // coloris indisponible
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'tcm__chip';
      b.style.backgroundColor = o.hex;
      b.setAttribute('aria-label', o.name);
      b.setAttribute('data-tcm-chip', o.handle);
      chips.appendChild(b);
    });
  }

  function getOpt(handle) {
    for (var i = 0; i < opts.length; i++) { if (opts[i].handle === handle) return opts[i]; }
    return null;
  }

  function choose(handle) {
    var o = getOpt(handle);
    if (!o || !modal) return;
    selected = o;
    var photo = modal.querySelector('[data-tcm-photo]');
    photo.style.opacity = '0.3';
    var pre = new Image();
    pre.onload = pre.onerror = function () { photo.src = o.img; photo.style.opacity = '1'; };
    pre.src = o.img;
    modal.querySelector('[data-tcm-name]').textContent = o.name;
    modal.querySelectorAll('[data-tcm-chip]').forEach(function (c) {
      c.classList.toggle('is-active', c.getAttribute('data-tcm-chip') === handle);
    });
    modal.querySelector('[data-tcm-validate]').disabled = false;
  }

  function setBusy(on, label) {
    if (!modal) return;
    modal.classList.toggle('is-busy', on);
    var v = modal.querySelector('[data-tcm-validate]');
    if (on) v.disabled = true; else v.disabled = !selected;
    modal.querySelector('[data-tcm-vlabel]').textContent = label || 'Valider mon coloris';
  }

  function openModal() {
    opts = getOpts();
    if (!modal) modal = buildModal();
    renderChips();
    var card = document.querySelector('[data-tc]');
    var currentHandle = card ? card.getAttribute('data-tc-sel') : '';
    closeDrawer(); // le tiroir passe sous le pop-up : on le ferme
    modal.classList.remove('is-leaving');
    modal.querySelector('[data-tcm-err]').classList.remove('is-visible');
    selected = null;
    setBusy(false);
    modal.classList.add('is-open');
    document.body.style.overflow = 'hidden';
    modal.querySelector('[data-tcm-name]').textContent = 'Touchez une pastille pour voir le coloris';
    modal.querySelector('[data-tcm-photo]').src = opts.length ? opts[0].img : '';
    if (currentHandle && getOpt(currentHandle)) choose(currentHandle);
  }

  /* Ferme le pop-up sans toucher au scroll (le tiroir ouvert le gère) */
  function hideModal(fade) {
    if (!modal || !modal.classList.contains('is-open')) return;
    if (!fade) {
      modal.classList.remove('is-open', 'is-busy', 'is-leaving');
      return;
    }
    modal.classList.add('is-leaving');
    setTimeout(function () {
      modal.classList.remove('is-open', 'is-busy', 'is-leaving');
    }, 260);
  }

  function closeModal() {
    if (!modal || !modal.classList.contains('is-open') || modal.classList.contains('is-busy')) return;
    hideModal(false);
    document.body.style.overflow = '';
    openDrawer();
  }

  /* Tiroir ouvert d'abord sous le pop-up, puis le pop-up disparaît en fondu */
  function finish(promise) {
    return promise.then(function () {
      openDrawer();
      setTimeout(function () { hideModal(true); }, 180);
    }, function () {
      setBusy(false);
      modal.querySelector('[data-tcm-err]').classList.add('is-visible');
    });
  }

  function validate() {
    if (!selected || !modal || modal.classList.contains('is-busy')) return;
    var o = selected;
    modal.querySelector('[data-tcm-err]').classList.remove('is-visible');
    setBusy(true, 'Ajout au panier…');
    finish(updateTotes(o.handle, o.variant).catch(function (err) {
      /* les lignes ont pu être modifiées sans que le tiroir se rafraîchisse */
      if (err && err.message === 'sections') reloadAndReopen();
      throw err;
    }));
  }

  function decline(card) {
    if (modal && modal.classList.contains('is-open')) {
      if (modal.classList.contains('is-busy')) return;
      modal.querySelector('[data-tcm-err]').classList.remove('is-visible');
      setBusy(true, 'Un instant…');
      finish(updateTotes(null, null));
      return;
    }
    /* depuis la carte, tiroir ouvert : on met juste à jour sur place */
    if (card) card.classList.add('is-busy');
    updateTotes(null, null).catch(function () {
      if (card) card.classList.remove('is-busy');
      reloadAndReopen();
    });
  }

  /* Boutons de la carte dans le tiroir — délégation : marche après chaque rendu */
  document.addEventListener('click', function (e) {
    var t = e.target;
    if (!t || !t.closest) return;
    if (t.closest('[data-tc-open]')) { e.preventDefault(); e.stopPropagation(); openModal(); return; }
    var dec = t.closest('[data-tc-decline]');
    if (dec) { e.preventDefault(); e.stopPropagation(); decline(dec.closest('[data-tc]')); }
  }, true);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', reopenAfterReload);
  } else {
    reopenAfterReload();
  }
})();
